module.exports = __webpack_public_path__ + "static/img/table.fbef280.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/table.png
// module id = 4YD0
// module chunks = 1